namespace TabAurous.ProductDevelopment {
    export interface RequirementStoneItemsRow {
        TransItemId?: number;
        TransDetailId?: number;
        ProductTypeId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        ShapeCode?: string;
        ShapeName?: string;
        QualityName?: string;
        QualityCode?: string;
        StoneColorCode?: string;
        StoneColoreName?: string;
        StoneSizeName?: string;
        Pieces?: number;
        Weight?: number;
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        CostMethodId?: number;
        MetalId?: number;
        AttributeId?: number;
        HSN?: string;
        Studded?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        DeptName?: string;
        DiscountPer?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        MFAmount?: number;
        MF?: number;
        ExportPieces?: number;
        HUID?: string;
        StampId?: number;
        StockAllocation?: boolean;
        StoneRate?: number;
        OtherRate?: number;
        FancyCharges?: number;
        OtherCharges?: number;
    }

    export namespace RequirementStoneItemsRow {
        export const idProperty = 'TransDetailId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'ProductDevelopment.RequirementStoneItems';
        export const deletePermission = 'ProductDevelopment:Requirement:Delete';
        export const insertPermission = 'ProductDevelopment:Requirement:Add';
        export const readPermission = '*';
        export const updatePermission = 'ProductDevelopment:Requirement:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransDetailId = "TransDetailId",
            ProductTypeId = "ProductTypeId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            ShapeCode = "ShapeCode",
            ShapeName = "ShapeName",
            QualityName = "QualityName",
            QualityCode = "QualityCode",
            StoneColorCode = "StoneColorCode",
            StoneColoreName = "StoneColoreName",
            StoneSizeName = "StoneSizeName",
            Pieces = "Pieces",
            Weight = "Weight",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            CostMethodId = "CostMethodId",
            MetalId = "MetalId",
            AttributeId = "AttributeId",
            HSN = "HSN",
            Studded = "Studded",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DeptName = "DeptName",
            DiscountPer = "DiscountPer",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            MFAmount = "MFAmount",
            MF = "MF",
            ExportPieces = "ExportPieces",
            HUID = "HUID",
            StampId = "StampId",
            StockAllocation = "StockAllocation",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges"
        }
    }
}
